import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as routeBound from '../../../route-bound'
import type { Feature } from '../feature'

/**
 * Executes load requests against the survey configuration API
 */
export const loadOnRequest = store.effects.create(
  (feature: Feature, Context$: routeBound.scenario.Context.Stream) =>
    feature.actions.load.request.observe().pipe(
      rxjs.withLatestFrom(Context$),
      rxjs.switchMap(([action, context]) => {
        if (!context) {
          // This is a defensive fallback only. The context-change effect is
          // responsible for clearing state and skipping loads when no scenario
          // context is active.
          return rxjs.of(
            feature.actions.load.cancellation.from(action).create({
              reason: 'No scenario context available',
              request: action.data,
            }),
          )
        }

        return feature.api.get(context).pipe(
          // Cancel the in-flight request as soon as feature state is cleared so
          // that a stale response cannot repopulate invalidated data.
          rxjs.takeUntil(feature.actions.clear.observe()),
          rxjs.map(response =>
            feature.actions.load.success.from(action).create({
              request: action.data,
              response,
            }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.load.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        )
      }),
    ),
)
